export const faqMenu = [
  {
    title: 'Certificado Digital',
    url_router: 'certificado-digital',
    items: [
      {
        title: 'O que é Certificado Digital?',
        content:
          'O Certificado Digital é a identidade eletrônica da pessoa física ou jurídica em ambiente virtual. É o documento eletrônico que identifica e gera a assinatura digital do seu titular.',
      },
      {
        title: 'Qual a diferença entre o A1 e o A3?',
        content:
          'A principal diferença entre os certificados digitais A1 e A3 reside no modo como são armazenados.<br><br> O certificado A1 é emitido e salvo diretamente no computador do usuário, sendo acessado por meio de uma senha para garantir a segurança.<br><br> Já os certificados A3 são armazenados em mídias externas, como cartões, tokens USB ou até em plataformas de nuvem, o que adiciona uma camada de mobilidade e segurança, pois exigem a presença física da mídia ou o acesso à nuvem para a utilização do certificado.',
      },
      {
        title: 'O que é o Certificado e-CPF?',
        content:
          'O Certificado e-CPF é a versão digital do CPF, servindo como identidade eletrônica para pessoas físicas. Ele permite identificar usuários em transações online, autenticar documentos e acessar serviços públicos e privados.',
      },
      {
        title: 'O que é o Certificado e-CNPJ?',
        content:
          'O Certificado e-CNPJ é uma versão digital do CNPJ (Cadastro Nacional da Pessoa Jurídica) que funciona como uma identidade eletrônica para empresas. Ele permite que uma pessoa jurídica seja identificada e realize transações seguras na internet com validade jurídica, de maneira semelhante ao e-CPF, mas voltado especificamente para empresas.',
      },
      {
        title: 'O que é o Certificado e-PJ?',
        content:
          'O Certificado e-PJ é a versão digital do CNPJ voltada para a identificação eletrônica de uma pessoa jurídica, ou seja, de uma empresa. Ele permite que a empresa realize transações online de maneira segura, autentique documentos digitais e tenha acesso a serviços governamentais e privados com validade jurídica.',
      },
    ],
  },
  {
    title: 'Emissão por Videoconferência',
    url_router: 'emissao-por-videoconferencia',
    items: [
      {
        title: 'Como funciona a emissão por videoconferência?',
        content:
          'A emissão de Certificados Digitais por videoconferência é um processo ágil que começa com o agendamento da chamada com a autoridade certificadora (AC). Durante a videoconferência, o operador verifica a identidade do solicitante por meio de documentos, coleta as informações necessárias e, após a verificação, gera o Certificado Digital. O certificado é então enviado ao usuário por e-mail ou disponibilizado para download. Além disso, a AC pode oferecer suporte técnico para a instalação e uso do certificado, tornando o processo mais prático e conveniente, sem necessidade de comparecimento físico.',
      },
      {
        title: 'Qual a duração de uma videoconferência?',
        content:
          'A videoconferência leva entre 3 e 5 minutos. Como ela é necessária para confirmar seu cadastro, pedimos que você esteja em um local reservado, livre de ruídos, bem iluminado e tenha em mãos seu documento de identificação (o mesmo que foi enviado anteriormente).',
      },
      {
        title: 'Como eu faço para acessar a videoconferência?',
        content:
          'No horário agendado, você receberá um link para acessar à videoconferência no e-mail cadastrado na solicitação, juntamente ao código de acesso. Neste momento, um agente de registro já estará lhe aguardando na sala para realizar a confirmação de cadastro.',
      },
      {
        title: 'Quais opções de Certificado posso fazer por videoconferência?',
        content:
          'Você pode adquirir os Certificados Digitais e-CPF ou e-CNPJ, disponíveis nos tipos A1 (armazenado no computador) e A3 (armazenado em mídia externa ou SafeID em nuvem). É importante que você já tenha realizado um Certificado Digital anteriormente para ter a biometria cadastrada, ou que possua CNH, pois isso permitirá a análise da sua identidade no banco de dados.',
      },
    ],
  },
  {
    title: 'Emissão presencial',
    url_router: 'emissao-presencial',
    items: [
      {
        title: 'Como funciona a emissão presencial?',
        content: `
            A emissão presencial oferece a possibilidade de escolher o local mais conveniente para a emissão do seu Certificado, garantindo todo o suporte necessário durante o processo.<br><br>
            Passo a passo: <br><br>
            <ol>
                <li>1.	Aquisição do Certificado</li>
                <li>2.	Agendamento do atendimento</li>
                <li>3.	Verificação dos documentos </li>
                <li>4.	Atendimento presencial para a emissão</li>
            </ol>
        `,
      },
      {
        title: 'Não estou conseguindo reagendar, o que fazer?',
        content:
          'Entre em contato com o suporte ao cliente. Tenha em mãos seus dados de agendamento para facilitar a identificação.',
      },
      {
        title: 'Qual é a duração de uma emissão presencial?',
        content:
          'Na emissão presencial, são feitas a análise dos documentos, a confirmação dos dados cadastrados, a identificação do titular e a coleta das informações biométricas, o que leva de 5 a 15 minutos.',
      },
      {
        title: 'Quais opções de Certificado posso fazer presencialmente?',
        content:
          'Você pode comprar os produtos e-CPF, e-CNPJ ou PJ NF-e, nos tipos A1 (computador) ou A3 (cartão, token, cartão + leitora ou em nuvem).',
      },
    ],
  },
  {
    title: 'Renovação',
    url_router: 'renovacao',
    items: [
      {
        title: 'Como funciona a renovação?',
        content: `
            A Renovação permite que você emita um novo Certificado Digital a partir de outro certificado válido já existente. Todo o processo de validação pode ser feito pelo cliente no momento da compra. <br><br>
            Passo a passo: <br><br>
            <ol>
                <li>1.	Escolha do certificado </li>
                <li>2.	Validação do certificado válido já existente</li>
                <li>3.	Compra do certificado escolhido</li>
                <li>4.	Emissão</li>
            </ol>
        `,
      },
    ],
  },
  {
    title: 'Documentação',
    url_router: 'documentacao',
    items: [
      {
        title: 'Quais documentos necessários para emitir o e-CPF?',
        content: ` Os documentos aceitos para emissão do e-CPF são: <br><br>
        <ol>
            <li>Cédula de identidade (CI/RG/DNI)</li>
            <li>Carteira Nacional de Habilitação (CNH)</li>
            <li>Carteira de Identidade Profissional (OAB, CRC, CRM, CRO e CREA)</li>
            <li>Carteira de Identidade de Estrangeiro (CIE, RNE, CRNM)</li>
            <li>Passaporte</li>
        </ol>
        `,
      },
      {
        title: 'Quais documentos necessários para emitir o e-PJ?',
        content: `Os documentos aceitos para emissão do e-PJ são: <br><br>
        <ol>
            <li>Cédula de identidade (CI/RG/DNI)</li>
            <li>Carteira Nacional de Habilitação (CNH)</li>
            <li>Carteira de Identidade Profissional (OAB, CRC, CRM, CRO e CREA)</li>
            <li>Carteira de Identidade de Estrangeiro (CIE, RNE, CRNM)</li>
            <li>Passaporte</li>
        </ol>
        `,
      },
      {
        title: 'O que faz em caso de falecimento de representante legal?',
        content: ` Existem as seguintes opções: <br><br>
        <ol>
        <li>1.	Emissão por meio do Redesim (é importante observar a nomenclatura que identifica o responsável). </li> <br><br>
        <li>2.	Emissão utilizando o Cartão CNPJ e o ato constitutivo da empresa, junto com uma das seguintes opções: </li> <br><br>
        </ol>

        - Apresentação do Termo de Inventariante, Termo de Compromisso de Inventariante, Inventário ou Escritura Pública Declaratória. Nesse caso, o inventariante deve ser indicado como representante legal na Receita Federal no momento da emissão. <br><br>

        - A Escritura Pública Declaratória deve mencionar quem foi designado como responsável pelo espólio e afirmar que essa pessoa pode realizar os atos relacionados à inventariança. <br><br>

        É fundamental lembrar que não é possível emitir um Certificado e-CPF em caso de falecimento do titular. `,
      },
      {
        title: 'Menores de idade pode emitir o Certificado Digital?',
        content:
          'Sim, menores de 18 anos podem obter um Certificado Digital, tanto para pessoa física quanto para jurídica. Para aqueles com mais de 16 anos, a apresentação da Certidão de Emancipação é obrigatória. Já os menores de 18 anos (não emancipados) e menores de 16 devem estar acompanhados de um responsável legal, que também deve apresentar documentos de identificação. Importante lembrar que apenas a via original ou cópia autenticada da Certidão de Emancipação será aceita para a emissão do certificado.',
      },
      {
        title: 'Posso emitir um Certificado com procuração?',
        content:
          'Sim, é possível emitir um Certificado Digital por meio de procuração. Neste caso, a pessoa que irá solicitar o certificado (procurador) deve apresentar a procuração devidamente assinada e reconhecer firma, além de apresentar seus documentos de identificação e, se necessário, os documentos do titular do certificado.',
      },
    ],
  },
  {
    title: 'Revogação',
    url_router: 'revogacao',
    items: [
      {
        title: 'Em que casos posso realizar uma revogação?',
        content: ` O processo de revogação poderá ser realizado durante todo o período de vigência do certificado. <br><br>

        <ol>
            <li>•	Emissão imprópria ou defeituosa do certificado</li>
            <li>•	Erro/Alteração/Atualização de informações de pessoa física ou jurídica (nome, RG, CNPJ, razão social, e-mail).</li>
            <li>•	Perda, roubo, modificação acesso indevido, comprometimento ou suspeita de comprometimento da chave privada correspondente ou da sua mídia armazenadora.</li>
            <li>•	Esquecimento ou bloqueio de senha da mídia armazenadora (Cartão Criptográfico ou Token).</li>
            <li>•	Desistência da compra do Certificado Digital (obedecendo ao prazo de 7 dias).</li>
        </ol>
        
        `,
      },
      {
        title: 'O que faço em caso de perda ou roubo do meu Certificado?',
        content: ` Indicamos que o titular realize a imediata revogação do Certificado extraviado. <br><br>
            Importante: o processo de revogação inutiliza o Certificado, portanto é necessário realizar uma nova aquisição.
          `,
      },
      {
        title: 'Desejo estornar minha compra o que fazer?',
        content: `
          O prazo para desistência da compra é de até sete dias, contados a partir da data de emissão/solicitação. <br><br>
          Para estornar a compra o cliente deve entrar em contato com o setor financeiro.
          `,
      },
    ],
  },
]
